import React from 'react';

import Badge from '@material-ui/core/Badge';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PagesIcon from '@material-ui/icons/Pages';

import {
  PERMISSAO_TELA_ESCALAS_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR,
  PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR,
  PERMISSAO_TELA_GRADE_HORARIOS_LISTAR,
  PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR,
  PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuPessoal = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  isGestor,
  isGerenteCaixa,
  permissoes,
  totalPendencias,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Pessoal"
    icon={<PagesIcon className={classes.icon} />}
  >
    <StyledMenuItemLink
      key="minhas-pendencias"
      to="/minhas-pendencias"
      primaryText="Minhas pendências"
      leftIcon={
        <Badge badgeContent={totalPendencias} color="error">
          <ListAltIcon className={classes.icon} />
        </Badge>
      }
      onClick={onMenuClick}
      sidebarIsOpen={open}
    />
    {permissoes[PERMISSAO_TELA_ESCALAS_LISTAR] && (
      <StyledMenuItemLink
        key="tabela-escalas"
        to="/tabela-escalas"
        primaryText="Escalas"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR] &&
      hasResource('instancias_atividades_processos_colaborador')}
    {permissoes[PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR] &&
      hasResource('instancias_atividades_processos_gestor')}
    {permissoes[PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR] &&
      hasResource('feriados_pessoal')}
    {permissoes[PERMISSAO_TELA_GRADE_HORARIOS_LISTAR] && (
      <StyledMenuItemLink
        key="grade-horarios"
        to="/grade-horarios"
        primaryText="Grade de Horários"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR] &&
      hasResource('qrcodes_gerentes')}
    {permissoes[PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR] &&
      hasResource('trocos_transportadores')}
  </SubMenu>
);

export default SubMenuPessoal;
